export default "__VITE_ASSET__C$OS9VJn__"